import React from 'react'
import { CircularProgress } from '@material-ui/core'
import { useSelector } from 'react-redux'
export default function Delete(props) {
    const general = useSelector(state => state.general)
    let {modal_data}=props
    const onClickDelete=async ()=>{
        let res= await props.modal_data.actionDelete()
        if(res){
            props.modalToggleReset()
            props.modal_data.getAction()
        }
    }
    return (
        <div>
            <div className='delete-container'>
                <p className='font-lato delete-title'>{modal_data.title}</p>
                <p className='font-lato delete-desc'>{modal_data.desc}</p>
                <div className='div-flex'>
                    <button className='btn-forum-outlined' onClick={props.modalToggleReset}>Kembali</button>
                    &nbsp;&nbsp;
                    <button onClick={onClickDelete} className='btn-forum'>
                    {general.isLoading?
                    <CircularProgress style={{color:'white'}}  size={20} />
                    :
                    modal_data.btn_delete
                    }</button>
                </div>
            </div>
        </div>
    )
}
